import Backbone from 'backbone';
import ko from 'knockout';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import state from '@bingads-webui-component-legacy/state/index';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import { queryify } from '@bingads-webui/url-util';
import ViewModel from '@bingads-webui-campaign-legacy/adextension-call/viewmodel/call-metering';
import template from '@bingads-webui-campaign-legacy/adextension-call/template/call-metering.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!global');

const callfeesUrl = queryify('/campaign/CallAdExtensions.m/GetAllowedCountryCallFees', {
  aid: state.get('account_id'),
  cid: state.get('customer_id'),
  uid: state.get('user_id'),
});

export default class CallMetering extends Backbone.View {
  initialize({
    viewModel: {
      CountryCode,
      IsCallTrackingEnabled,
      RequireTollFreeTrackingNumber,
      $overall,
    } = {},
    field = {},
  } = {}) {
    this.$overall = $overall;
    this.field = field;

    this.p$init = jsdata.Country.find('CallFees', { url: callfeesUrl, adapter: 'legacy' })
      .then(({ AllowedCountries, CallFees }) => {
        this.viewModel = new ViewModel({
          AllowedCountries,
          CallFees,
          CountryCode,
          IsCallTrackingEnabled,
          RequireTollFreeTrackingNumber,
        });
      })
      .finally(withUiBlock(this.$el.parent()));
  }

  render() {
    this.p$init.then(() => {
      this.$el.html(template({ i18n, id: this.field.id }));

      ko.applyBindings(this.viewModel, this.el);
    })
      .catch(() => {
        this._handleErrors();
      });

    return this;
  }

  _handleErrors() {
    this.$overall.validators.passive.setError(i18nGlobal.get('GenericErrorMessage'));
    this.$overall.validate();
  }
}
